import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import "./startScheduling.css"
import { navigate } from "gatsby"
import image1 from "../../../../static/images/logo.svg"
import LogoGreen from "../../../../static/images/images/logo-green.svg"
import BookingSteps from "../components/WelcomeSteps"

export const StartScheduling = ({ insuranceName, onSubmit }) => {
  const handleClick = () => {
    navigate("/")
  }

  const [isLoading, setIsLoading] = useState(false)
  const [emptyResults, setEmptyResults] = useState(false)

  const handleSubmit = () => {
    setIsLoading(true)
    onSubmit(setEmptyResults)
  }

  if (isLoading) {
    return (
      <div className="loader">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="img-wrapper">
                <img alt="Logo" className="img-fluid" src={LogoGreen} />
              </div>
              <div className="content">
                {!emptyResults && <h5 className="save-title">Loading...</h5>}
                <p className="save-content">
                  {emptyResults ? (
                    <>
                      Sorry, we are having trouble finding openings. Please
                      reach out to{" "}
                      <a href="mailto:scheduling@corticacare.com">
                        scheduling@corticacare.com
                      </a>{" "}
                      or call an enrollment specialist at{" "}
                      <a href="tel:888-885-5068">888-885-5068</a> to book your
                      Welcome Visit.
                    </>
                  ) : (
                    "We are searching for appointments!"
                  )}
                </p>
                {emptyResults && (
                  <button className="btn btn-home" onClick={handleClick}>
                    Back to Website
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <section>
        <div className="logo-header">
          <img alt="logo" src={image1} />
        </div>
      </section>
      <section>
        <div className="body-container">
          <div className="body-content">
            <div className="header">
              <h2>Now let&apos;s book your Welcome Visit.</h2>
            </div>
            <div className="main-content">
              <p>
                In this 60-minute telehealth appointment, you&apos;ll meet with
                one of our nurse practitioners to start the diagnosis process
                (if you do not already have a diagnosis), discuss your
                child&apos;s needs, and confirm your insurance benefits.
              </p>
              <p>
                <b>
                  Click on the &quot;Start Scheduling&quot; button to book your
                  appointment.
                </b>
              </p>
            </div>
            <BookingSteps />
            <div className="buttons-container">
              <div>
                <button
                  className="btn btnclose exit"
                  onClick={handleClick}
                  type="button"
                >
                  Exit
                </button>
              </div>
              <div>
                <button
                  className="btn btn-yellow"
                  onClick={handleSubmit}
                  type="button"
                >
                  Start Scheduling
                </button>
              </div>
            </div>
            <div className="enroll-prefooter">
              <p style={{ textAlign: "center" }}>
                Questions? Our enrollment team is available to help! Please call
                us at <a href="tel:+8888855068">888-885-5068</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

StartScheduling.propTypes = {
  insuranceName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
}
